export const VARIANTS_MAIN_MENU = {
	open: {
		width: '300px',
		transition: {
			type: 'spring',
			duration: 0.1,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
	closed: {
		width: '92px',
		transition: {
			type: 'spring',
			duration: 0.1,
			staggerChildren: 0.05,
			staggerDirection: -1,
		},
	},
};

export const VARIANTS_MODAL = {
	open: {
		y: '3vh',

		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
	closed: {
		y: -500,
		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.05,
			staggerDirection: -1,
		},
	},
};

export const VARIANTS_MODAL_BG_MODAL = {
	open: {
		opacity: 1,
		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
	closed: {
		opacity: 0,
		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.05,
			staggerDirection: -1,
		},
	},
};

export const IMAGE_LARGE = {
	open: {
		opacity: 1,
		scale: 1,
		x: 20,
		transition: {
			duration: 1.2,
		},
	},
	closed: {
		opacity: 0,
		scale: 1,
		x: -50,
		transition: {
			duration: 0.8,
			type: 'spring',
			stiffness: 400,
			damping: 40,
		},
	},
};

export const IMAGE_SMALL = {
	open: {
		opacity: 0,
		scale: 1,
		x: 90,
		transition: {
			duration: 0.8,
			type: 'spring',
			stiffness: 400,
			damping: 40,
		},
	},
	closed: {
		opacity: 1,
		scale: 1,
		x: 20,
		transition: {
			duration: 0.8,
			type: 'spring',
			stiffness: 400,
			damping: 40,
		},
	},
};

export const VARIANTS_ICON_CLOSE = {
	open: {
		rotate: -180,
		right: '-32px',
		transition: {
			duration: 0.5,
			type: 'spring',
			stiffness: 400,
			damping: 40,
		},
	},
	closed: {
		rotate: 0,
		right: '-22px',
		transition: {
			duration: 0.5,
			type: 'spring',
			stiffness: 400,
			damping: 40,
		},
	},
};

export const VARIANTS_COMPANY_BOX = {
	open: {
		opacity: 0,
		x: -50,
		transition: {
			duration: 1.5,
		},
	},
	closed: {
		opacity: 1,
		x: 0,
		transition: {
			duration: 1.2,
		},
	},
};

export const VARIANTS_COMPANY_BOX_ICON = {
	open: {
		opacity: [0, 1],
		scale: [0, 1],
		transition: {
			duration: 1.2,
		},
	},
	closed: {
		opacity: [0, 1],
		scale: [0, 1],
		transition: {
			duration: 1.2,
		},
	},
};

export const VARIANTS_ITEM_MENU = {
	open: {
		opacity: 1,
		x: 0,
		scale: 1,
		display: 'block',
		transition: {
			duration: 0.8,
		},
	},
	closed: {
		opacity: 0,
		x: -400,
		display: 'none',
		scale: 0,
		transition: {
			duration: 0.8,
		},
	},
};

export const VARIANTS_ITEM_ICON = {
	open: {
		opacity: 1,
		x: [0, -10, 0],
		transition: {
			duration: 1.2,
		},
	},
	closed: {
		opacity: 1,
		x: 0,
		transition: {
			duration: 1.2,
		},
	},
};

export const VARIANTS_TOAST_ALERT = {
	open: {
		opacity: [0, 0.5, 1],
		y: [0, -10, -100],
		transition: {
			duration: 0.8,
		},
	},
	closed: {
		opacity: [1, 0.5, 0],
		y: [-100, -10, 0],
		transition: {
			duration: 0.8,
		},
	},
};

export const VARIANTS_SLIDE = {
	open: {
		opacity: [0, 0.5, 1],
		x: [200, 100, 50, 0],
		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
	closed: {
		opacity: [1, 0.5, 0],
		x: [0, -50, -100, -200],
		transition: {
			type: 'spring',
			duration: 1.5,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
};

export const VARIANTS_SUB_MENU_DROPDOWN = {
	open: {
		opacity: 1,
		y: -1,
		transition: {
			duration: 0,
		},
	},
	closed: {
		opacity: 0,
		y: -40,
		transition: {
			duration: 0,
		},
	},
};

export const VARIANTS_SUB_MENU_DROPDOWN_WITH_OUT_SEARCH = {
	open: {
		opacity: 1,
		y: -1,
		transition: {
			duration: 0,
		},
	},
	closed: {
		opacity: 0,
		y: -45,
		transition: {
			duration: 0,
		},
	},
};

export const VARIANTS_SUB_MENU_DROPDOWN_DOWN = {
	open: {
		opacity: 1,
		bottom: 58,
		transition: {
			duration: 0.5,
		},
	},
	closed: {
		opacity: 0,
		bottom: 28,
		transition: {
			duration: 0.5,
		},
	},
};

export const VARIANTS_SUB_MENU_DROPDOWN_DOWN_WITH_OUT_SEARCH = {
	open: {
		opacity: 1,
		bottom: 58,
		transition: {
			duration: 0.5,
		},
	},
	closed: {
		opacity: 0,
		bottom: 28,
		transition: {
			duration: 0.5,
		},
	},
};
